import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgMijnParkeerplaats = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <mask
      id="Mijn_parkeerplaats_svg__a"
      width={18}
      height={26}
      x={11}
      y={7}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M29 7v26H11V7z"
        clipRule="evenodd"
      />
    </mask>
    <g mask="url(#Mijn_parkeerplaats_svg__a)">
      <path
        fill="#F8C9E9"
        d="m-4.49 5.86 12.24 7.07L14.82.68z"
      />
      <path
        fill="#F29FC5"
        d="M7.75 12.93.68 25.18 20 20z"
      />
      <path
        fill="#F8C9E9"
        d="m5.86 44.49 7.07-12.24L.68 25.18zM20 20l-7.07 12.25 12.25 7.07 7.07-12.25z"
      />
      <path
        fill="#F29FC5"
        d="M34.14-4.49 14.82.68l12.25 7.07zM39.32 14.82 27.07 7.75 20 20z"
      />
      <path
        fill="#F8C9E9"
        d="m5.86 44.49 19.32-5.17-12.25-7.07zM.68 25.18l12.25 7.07L20 20z"
      />
      <path
        fill="#F29FC5"
        d="m20 20 12.25 7.07 7.07-12.25zM44.49 34.14l-12.24-7.07-7.07 12.25zM14.822.685 7.752 12.93 19.998 20l7.07-12.245zM34.14-4.49 27.07 7.75l12.25 7.07z"
      />
    </g>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M22 18c0 1.1-.9 2-2 2h-2v-4h2c1.1 0 2 .9 2 2m3 0c0-2.76-2.24-5-5-5h-5v15h3v-5h2c2.76 0 5-2.24 5-5"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgMijnParkeerplaats);

export default ForwardRef;
